import React from "react";
import { Route, Redirect } from "react-router-dom";
import { Login } from "../components/login/login";
export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      // <Component {...props} {...rest} />
      localStorage.getItem("__user") ? (
        <Component {...props} {...rest} />
      ) : (
        <Login />
      )
    }
  />
);
